import clsx from "clsx";
import React from "react";
import { Delegator, Seller } from "types";
import { getDefaultLogoUrl } from "@/models/Seller";

type SellerLogoProps = {
    seller: Seller | Delegator;
    size?: "small" | "medium";
};

export const SellerLogo = ({ seller, size = "medium" }: SellerLogoProps) => {
    const sizeClasses = clsx({
        "h-5 w-5": size === "small",
        "h-7 w-7": size === "medium",
    });

    return (
        <img
            alt={`Logo for ${seller.name}`}
            src={getDefaultLogoUrl(seller, "small")}
            className={clsx("no-translate rounded-full", sizeClasses)}
        />
    );
};
